module.exports = __webpack_public_path__ + "img/chevron-down.645cecf4.svg";